export default __webpack_public_path__ + "static/media/Dial_White.d94569ae.png";